/** sessionStorage — after intro completes, /login is allowed without redirecting back to /intro */
export const INTRO_SESSION_KEY = 'sp_intro_seen';

/**
 * Public file in `public/` (must match filename on disk).
 * Uses Vite BASE_URL so it works when deployed in a subfolder.
 */
export const INTRO_VIDEO_PUBLIC_PATH = `${import.meta.env.BASE_URL}intro.mp4`;

/**
 * Fallback list for legacy deployments where the file was uploaded
 * with the old WhatsApp filename or under root.
 */
export const INTRO_VIDEO_CANDIDATES = [
  INTRO_VIDEO_PUBLIC_PATH,
  `${import.meta.env.BASE_URL}WhatsApp Video 2026-04-23 at 1.36.07 PM.mp4`,
  '/intro.mp4',
  '/WhatsApp Video 2026-04-23 at 1.36.07 PM.mp4',
];
